import Drawflow from 'drawflow'

const ROTULOS = {
  oportunidade_ganha: {
    titulo: 'Gatilho',
    texto: 'Oportunidade ganha',
  },
  mudanca_fase: {
    titulo: 'Gatilho',
    texto: 'Mudança de fase',
  },
  oportunidade_criada: {
    titulo: 'Gatilho',
    texto: 'Criação de oportunidade',
  },
  mudanca_status: {
    titulo: 'Gatilho',
    texto: 'Mudança de status',
  },
  oportunidade_perdida: {
    titulo: 'Gatilho',
    texto: 'Oportunidade perdida',
  },
  cadastro_cliente: {
    titulo: 'Gatilho',
    texto: 'Cadastro de cliente',
  },
  resposta_mensagem: {
    titulo: 'Gatilho',
    texto: 'Resposta de mensagem',
  },
  preenchimento_campo: {
    titulo: 'Gatilho',
    texto: 'Preenchimento de campo',
  },
  pipeline_id: {
    titulo: 'Condição',
    texto: 'Pipeline',
  },
  valor: {
    titulo: 'Condição',
    texto: 'Valor',
  },
  origem: {
    titulo: 'Condição',
    texto: 'Origem',
  },
  horario: {
    titulo: 'Condição',
    texto: 'Horário',
  },
  campo: {
    titulo: 'Condição',
    texto: 'Campo',
  },
  resposta: {
    titulo: 'Condição',
    texto: 'Resposta',
  },
  criar_oportunidade: {
    titulo: 'Ação',
    texto: 'Aproveita a atual',
  },
  notificar_gestor: {
    titulo: 'Ação',
    texto: 'Notificar gestor',
  },
  mover_fase: {
    titulo: 'Ação',
    texto: 'Mover fase',
  },
  criar_tarefa: {
    titulo: 'Ação',
    texto: 'Criar tarefa',
  },
  enviar_mensagem: {
    titulo: 'Ação',
    texto: 'Enviar mensagem',
  },
  alterar_responsavel: {
    titulo: 'Ação',
    texto: 'Alterar responsável',
  },
  atualizar_campo: {
    titulo: 'Ação',
    texto: 'Atualizar campo',
  },
}

const DADOS_PADRAO = {
  oportunidade_ganha: {
    tipo_no: 'gatilho',
    tipo: 'oportunidade_ganha',
  },
  mudanca_fase: {
    tipo_no: 'gatilho',
    tipo: 'mudanca_fase',
    pipeline_id: null,
    fase_regra: 'qualquer',
    fase_de: null,
    fase_para: null,
  },
  oportunidade_criada: {
    tipo_no: 'gatilho',
    tipo: 'oportunidade_criada',
  },
  mudanca_status: {
    tipo_no: 'gatilho',
    tipo: 'mudanca_status',
  },
  oportunidade_perdida: {
    tipo_no: 'gatilho',
    tipo: 'oportunidade_perdida',
  },
  cadastro_cliente: {
    tipo_no: 'gatilho',
    tipo: 'cadastro_cliente',
  },
  resposta_mensagem: {
    tipo_no: 'gatilho',
    tipo: 'resposta_mensagem',
  },
  preenchimento_campo: {
    tipo_no: 'gatilho',
    tipo: 'preenchimento_campo',
  },
  pipeline_id: {
    tipo_no: 'condicao',
    tipo: 'pipeline_id',
    op: '=',
    valor: null,
  },
  valor: {
    tipo_no: 'condicao',
    tipo: 'valor',
    op: '>=',
    valor: null,
  },
  origem: {
    tipo_no: 'condicao',
    tipo: 'origem',
    op: '=',
    valor: 'whatsapp',
  },
  horario: {
    tipo_no: 'condicao',
    tipo: 'horario',
    semana: [
      { dia: 1, ativo: true, inicio: '08:00', fim: '18:00' },
      { dia: 2, ativo: true, inicio: '08:00', fim: '18:00' },
      { dia: 3, ativo: true, inicio: '08:00', fim: '18:00' },
      { dia: 4, ativo: true, inicio: '08:00', fim: '18:00' },
      { dia: 5, ativo: true, inicio: '08:00', fim: '18:00' },
      { dia: 6, ativo: false, inicio: '08:00', fim: '12:00' },
      { dia: 0, ativo: false, inicio: '08:00', fim: '12:00' },
    ],
    excecoes: [],
  },
  campo: {
    tipo_no: 'condicao',
    tipo: 'campo',
    campo_id: null,
    op: 'preenchido',
    valor: null,
  },
  resposta: {
    tipo_no: 'condicao',
    tipo: 'resposta',
    op: 'respondeu',
    valor: null,
  },
  criar_oportunidade: {
    tipo_no: 'acao',
    tipo: 'criar_oportunidade',
    origem: 'atual',
    nome: '',
    herdar_responsavel: true,
    user_id: 'atual',
    pipeline_id: null,
    fase_id: null,
  },
  notificar_gestor: {
    tipo_no: 'acao',
    tipo: 'notificar_gestor',
    alvo: 'atual',
  },
  mover_fase: {
    tipo_no: 'acao',
    tipo: 'mover_fase',
    pipeline_id: null,
    fase_id: null,
    alvo: 'atual',
  },
  criar_tarefa: {
    tipo_no: 'acao',
    tipo: 'criar_tarefa',
    titulo: '',
    tipo_tarefa: 'ligar',
    descricao: '',
    prazo_dias: 0,
    alvo: 'atual',
  },
  enviar_mensagem: {
    tipo_no: 'acao',
    tipo: 'enviar_mensagem',
    canal: 'email',
    config_eloca_hyperflow_id: null,
    template_id: null,
    aguardar_resposta: '0',
    prazo_horas: 24,
    assunto: '',
    corpo: '',
    destinatario_email_tipo: 'cliente',
    destinatario_email: '',
    alvo: 'atual',
  },
  alterar_responsavel: {
    tipo_no: 'acao',
    tipo: 'alterar_responsavel',
    user_id: null,
    alvo: 'atual',
  },
  atualizar_campo: {
    tipo_no: 'acao',
    tipo: 'atualizar_campo',
    campo_id: null,
    campo_valor: '',
    alvo: 'atual',
  },
}

const ICONES = {
  oportunidade_ganha: 'fas fa-trophy',
  mudanca_fase: 'fas fa-exchange-alt',
  oportunidade_criada: 'fas fa-folder-plus',
  mudanca_status: 'fas fa-flag',
  oportunidade_perdida: 'fas fa-times-circle',
  cadastro_cliente: 'fas fa-user-plus',
  resposta_mensagem: 'fas fa-reply',
  preenchimento_campo: 'fas fa-check-square',
  pipeline_id: 'fas fa-filter',
  valor: 'fas fa-dollar-sign',
  origem: 'fas fa-globe',
  horario: 'fas fa-clock',
  campo: 'fas fa-list',
  resposta: 'fas fa-comment-dots',
  criar_oportunidade: 'fas fa-plus',
  notificar_gestor: 'fas fa-bell',
  mover_fase: 'fas fa-arrow-right',
  criar_tarefa: 'fas fa-tasks',
  enviar_mensagem: 'fas fa-comment',
  alterar_responsavel: 'fas fa-user-tag',
  atualizar_campo: 'fas fa-edit',
}

function htmlNo(tipo, data) {
  const rotulo = ROTULOS[tipo] || { titulo: tipo, texto: '' }
  const icone = ICONES[tipo] || 'fas fa-circle'
  const dados = data || DADOS_PADRAO[tipo] || {}
  const small = tipo === 'criar_oportunidade' ? tituloCriada(dados) : rotulo.titulo
  const strong = tipo === 'criar_oportunidade' ? 'Definir destino' : rotulo.texto

  return (
    '<div class="automacao-editor__no automacao-editor__no--' +
    (dados.tipo_no || tipo) +
    '">' +
    '<span class="automacao-editor__no-icone" aria-hidden="true"><i class="' +
    icone +
    '"></i></span>' +
    '<span class="automacao-editor__no-meta">' +
    '<small>' +
    small +
    '</small>' +
    '<strong>' +
    strong +
    '</strong>' +
    '</span>' +
    (dados.tipo_no === 'condicao'
      ? '<span class="automacao-editor__no-ramos" aria-hidden="true"><span>Sim</span><span>Não</span></span>'
      : '') +
    '</div>'
  )
}

function entradas(tipoNo) {
  return tipoNo === 'gatilho' ? 0 : 1
}

function saidas(tipoNo) {
  return tipoNo === 'condicao' ? 2 : 1
}

export function criarEditor(container, onSelect) {
  const editor = new Drawflow(container)
  editor.reroute = true
  editor.zoom_max = 1.6
  editor.zoom_min = 0.35
  editor.zoom_value = 0.08
  editor.start()
  container.classList.remove('parent-drawflow')
  container.className = ('parent-drawflow ' + container.className).trim()
  container.setAttribute('tabindex', '0')

  editor.on('nodeSelected', function (id) {
    const no = editor.getNodeFromId(id)
    if (onSelect) {
      onSelect(id, no)
    }
  })

  habilitarZoomScroll(container, editor)
  habilitarRemoverConexao(container, editor)

  return editor
}

function habilitarZoomScroll(container, editor) {
  container.addEventListener(
    'wheel',
    function (event) {
      event.preventDefault()
      if (event.deltaY > 0) {
        editor.zoom_out()
        return
      }
      editor.zoom_in()
    },
    { passive: false }
  )
}

function habilitarRemoverConexao(container, editor) {
  container.addEventListener('mousedown', function () {
    container.focus()
  })

  container.addEventListener('dblclick', function (event) {
    if (!event.target.classList.contains('main-path')) {
      return
    }
    if (editor.connection_selected && typeof editor.removeConnection === 'function') {
      editor.removeConnection()
    }
  })

  container.addEventListener('contextmenu', function (event) {
    if (!event.target.classList.contains('main-path') && !editor.connection_selected) {
      return
    }
    event.preventDefault()
    if (editor.connection_selected && typeof editor.removeConnection === 'function') {
      editor.removeConnection()
    }
  })

  container.addEventListener('keydown', function (event) {
    if (event.key !== 'Delete' && event.key !== 'Backspace') {
      return
    }
    if (editor.connection_selected && typeof editor.removeConnection === 'function') {
      event.preventDefault()
      editor.removeConnection()
    }
  })
}

export function importarCanvas(editor, canvas, contexto) {
  if (!canvas || !canvas.drawflow) {
    return
  }
  editor.import(canvas)
  garantirSaidasCondicao(editor)
  garantirCodigosCriarOportunidade(editor)
  atualizarRotulosCanvas(editor, contexto)
}

export function reiniciarVista(editor) {
  if (!editor) {
    return
  }
  editor.zoom = 1
  editor.zoom_last_value = 1
  editor.canvas_x = 0
  editor.canvas_y = 0
  if (editor.precanvas) {
    editor.precanvas.style.transform = 'translate(0px, 0px) scale(1)'
  }
}

export function carregarCanvas(editor, canvas, contexto) {
  const origem = (((canvas || {}).drawflow || {}).Home || {}).data || {}
  const ids = Object.keys(origem)
  if (!editor || !ids.length) {
    return 0
  }
  reiniciarVista(editor)
  editor.clear()
  const mapa = {}
  ids.forEach(function (id) {
    const no = origem[id]
    const tipo = (no.data && no.data.tipo) || ''
    const novoId = adicionarNo(editor, tipo, no.pos_x || 60, no.pos_y || 50)
    if (!novoId) {
      return
    }
    mapa[String(id)] = String(novoId)
    if (no.data) {
      atualizarDadosNo(editor, novoId, no.data, contexto)
    }
  })
  ids.forEach(function (id) {
    const de = mapa[String(id)]
    if (!de) {
      return
    }
    const saidasNo = origem[id].outputs || {}
    Object.keys(saidasNo).forEach(function (saida) {
      const conexoes = (saidasNo[saida] && saidasNo[saida].connections) || []
      conexoes.forEach(function (conexao) {
        const para = mapa[String(conexao.node)]
        if (!para || typeof editor.addConnection !== 'function') {
          return
        }
        editor.addConnection(de, para, saida, conexao.output || 'input_1')
      })
    })
  })
  layoutAutomatico(editor, contexto)
  if (!editor.precanvas) {
    return 0
  }

  return editor.precanvas.querySelectorAll('.drawflow-node').length
}

export function marcarErrosNos(editor, errosPorNo) {
  if (!editor || !editor.precanvas) {
    return
  }
  editor.precanvas.querySelectorAll('.drawflow-node.is-invalido').forEach(function (el) {
    el.classList.remove('is-invalido')
  })
  editor.precanvas.querySelectorAll('.automacao-editor__no-aviso').forEach(function (el) {
    el.remove()
  })
  Object.keys(errosPorNo || {}).forEach(function (id) {
    const mensagens = errosPorNo[id] || []
    if (!mensagens.length) {
      return
    }
    const el = editor.precanvas.querySelector('#node-' + id)
    if (!el) {
      return
    }
    el.classList.add('is-invalido')
  })
}

export function atualizarRotulosCanvas(editor, contexto) {
  if (!editor) {
    return
  }
  const data = (((editor.export() || {}).drawflow || {}).Home || {}).data || {}
  Object.keys(data).forEach(function (id) {
    aplicarRotuloNo(editor, id, data[id].data || {}, contexto)
  })
}

function garantirSaidasCondicao(editor) {
  const data = editor.export().drawflow.Home.data || {}
  Object.keys(data).forEach(function (id) {
    const no = data[id]
    const tipoNo = (no.data && no.data.tipo_no) || no.name
    if (tipoNo !== 'condicao') {
      return
    }
    if (Object.keys(no.outputs || {}).length >= 2) {
      return
    }
    editor.addNodeOutput(id)
  })
}

export function exportarCanvas(editor) {
  return editor.export()
}

export function contarNosPorTipo(editor, tipoNo) {
  const data = editor.export().drawflow.Home.data || {}
  return Object.values(data).filter(function (no) {
    return (no.data && no.data.tipo_no === tipoNo) || no.name === tipoNo
  }).length
}

export function contarNosPorTipoEspecifico(editor, tipo) {
  const data = editor.export().drawflow.Home.data || {}
  return Object.values(data).filter(function (no) {
    return no.data && no.data.tipo === tipo
  }).length
}

export function adicionarNo(editor, tipo, posX, posY) {
  const padrao = DADOS_PADRAO[tipo]
  if (!padrao) {
    return null
  }

  const tipoNo = padrao.tipo_no
  if (tipoNo === 'gatilho' && contarNosPorTipo(editor, 'gatilho') >= 1) {
    return null
  }
  if (tipoNo === 'acao' && contarNosPorTipoEspecifico(editor, tipo) >= 20) {
    return null
  }

  const dados = Object.assign({}, padrao)
  if (tipo === 'criar_oportunidade') {
    dados.codigo = proximoCodigoCriarOportunidade(editor)
  }

  return editor.addNode(
    tipoNo,
    entradas(tipoNo),
    saidas(tipoNo),
    posX,
    posY,
    'automacao-editor__no-wrap automacao-editor__no-wrap--' + tipoNo,
    dados,
    htmlNo(tipo, dados)
  )
}

export function atualizarDadosNo(editor, id, data, contexto) {
  const payload = Object.assign({}, data)
  editor.updateNodeDataFromId(id, payload)
  const nos = (((editor.drawflow || {}).drawflow || {}).Home || {}).data || {}
  if (nos[id]) {
    nos[id].data = payload
  } else if (nos[String(id)]) {
    nos[String(id)].data = payload
  }
  aplicarRotuloNo(editor, id, payload, contexto)
}

function aplicarRotuloNo(editor, id, data, contexto) {
  const meta = editor.precanvas.querySelector('#node-' + id + ' .automacao-editor__no-meta')
  if (!meta) {
    return
  }
  const small = meta.querySelector('small')
  const strong = meta.querySelector('strong')
  if (data && data.tipo === 'criar_oportunidade') {
    if (small) {
      small.textContent = tituloCriada(data)
    }
    if (strong) {
      strong.textContent = detalheOportunidadeCriada(data, contexto)
    }
    return
  }
  if (strong) {
    const texto = textoNo(data, editor)
    if (texto) {
      strong.textContent = texto
    }
  }
}

function textoNo(data, editor) {
  if (data && data.tipo === 'criar_tarefa') {
    return 'Tarefa ' + textoAlvo(data, editor)
  }
  if (data && data.tipo === 'enviar_mensagem') {
    return 'Mensagem ' + textoAlvo(data, editor)
  }
  if (data && data.tipo === 'mover_fase') {
    return 'Mover ' + textoAlvo(data, editor)
  }
  if (data && data.tipo === 'notificar_gestor') {
    return 'Avisar ' + textoAlvo(data, editor)
  }
  if (data && data.tipo === 'alterar_responsavel') {
    return 'Responsável ' + textoAlvo(data, editor)
  }
  if (data && data.tipo === 'atualizar_campo') {
    return 'Campo ' + textoAlvo(data, editor)
  }

  const rotulo = ROTULOS[data && data.tipo]
  const texto = rotulo ? rotulo.texto : ''
  if (data && data.tipo_no === 'condicao') {
    const quantidade = regrasDaCondicao(data).length
    if (quantidade > 1) {
      return texto + ' · ' + quantidade
    }
  }
  if (data && data.tipo === 'preenchimento_campo') {
    const quantidade = idsDoGatilho(data, 'campo_ids', 'campo_id').filter(function (id) {
      return id !== null && id !== undefined && id !== ''
    }).length
    if (quantidade > 1) {
      return texto + ' · ' + quantidade
    }
  }

  return texto
}

function textoAlvo(data, editor) {
  if (usaOportunidadeAtual(data)) {
    return 'na atual'
  }
  if (data.alvo === 'criada') {
    return 'na última criada'
  }
  const codigo = codigoDoAlvo(editor, data.alvo)
  return codigo ? 'em Criada ' + codigo : 'no fluxo'
}

function codigoDoAlvo(editor, alvo) {
  if (!editor || !alvo) {
    return ''
  }
  try {
    const no = editor.getNodeFromId(alvo)
    return (no && no.data && no.data.codigo) || ''
  } catch (erro) {
    return ''
  }
}

function usaOportunidadeAtual(data) {
  return !data.alvo || data.alvo === 'atual'
}

export function listarOportunidadesDoFluxo(editor, noAtualId, contexto) {
  const lista = [{ id: 'atual', rotulo: 'A que disparou o fluxo' }]
  if (!editor) {
    return lista
  }

  const data = (((editor.export() || {}).drawflow || {}).Home || {}).data || {}
  Object.keys(data).forEach(function (id) {
    if (String(id) === String(noAtualId || '')) {
      return
    }
    const noData = data[id].data || {}
    if (noData.tipo !== 'criar_oportunidade') {
      return
    }
    lista.push({
      id: String(id),
      rotulo: rotuloOportunidadeCriada(noData, contexto),
    })
  })

  return lista
}

function tituloCriada(data) {
  return data && data.codigo ? 'Criada ' + data.codigo : 'Criada'
}

function rotuloOportunidadeCriada(data, contexto) {
  const partes = [tituloCriada(data)]
  const pipeline = nomePorId(data.pipeline_id, contexto && contexto.pipelines)
  if (pipeline) {
    partes.push(pipeline)
  }
  return partes.join(' · ')
}

function detalheOportunidadeCriada(data, contexto) {
  const partes = []
  if (data.origem === 'nova' && data.nome && String(data.nome).trim()) {
    partes.push(String(data.nome).trim())
  }
  const pipeline = nomePorId(data.pipeline_id, contexto && contexto.pipelines)
  if (pipeline) {
    partes.push(pipeline)
  }
  const fases = fasesDoContexto(contexto, data.pipeline_id)
  const fase = nomePorId(data.fase_id, fases)
  if (fase) {
    partes.push(fase)
  }
  return partes.length ? partes.join(' · ') : 'Definir destino'
}

function fasesDoContexto(contexto, pipelineId) {
  if (!contexto || !contexto.fasesPorPipeline || !pipelineId) {
    return []
  }
  return contexto.fasesPorPipeline[pipelineId] || contexto.fasesPorPipeline[String(pipelineId)] || []
}

function nomePorId(id, itens) {
  if (!id || !itens || !itens.length) {
    return ''
  }
  const item = itens.find(function (opcao) {
    return String(opcao.id) === String(id)
  })
  return item ? item.value : ''
}

function proximoCodigoCriarOportunidade(editor) {
  const usados = {}
  const data = (((editor.export() || {}).drawflow || {}).Home || {}).data || {}
  Object.keys(data).forEach(function (id) {
    const noData = data[id].data || {}
    if (noData.tipo === 'criar_oportunidade' && noData.codigo) {
      usados[String(noData.codigo)] = true
    }
  })
  const letras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  for (let i = 0; i < letras.length; i++) {
    if (!usados[letras[i]]) {
      return letras[i]
    }
  }
  return String(Object.keys(usados).length + 1)
}

function garantirCodigosCriarOportunidade(editor) {
  const data = (((editor.export() || {}).drawflow || {}).Home || {}).data || {}
  Object.keys(data).forEach(function (id) {
    const noData = data[id].data || {}
    if (noData.tipo !== 'criar_oportunidade' || noData.codigo) {
      return
    }
    editor.updateNodeDataFromId(id, Object.assign({}, noData, {
      codigo: proximoCodigoCriarOportunidade(editor),
    }))
  })
}

export function posicaoDrop(container, event) {
  const rect = container.getBoundingClientRect()

  return {
    x: event.clientX - rect.left,
    y: event.clientY - rect.top,
  }
}

export function dadosDosNos(editor) {
  if (!editor) {
    return {}
  }

  return (((editor.export() || {}).drawflow || {}).Home || {}).data || {}
}

function tipoNoDoRegistro(no) {
  return (no && no.data && no.data.tipo_no) || (no && no.name) || ''
}

function filhosDaSaida(no, saida) {
  const conexoes = ((no && no.outputs && no.outputs[saida]) || {}).connections || []

  return conexoes.map(function (conexao) {
    return String(conexao.node)
  }).filter(Boolean)
}

function paisDoNo(data, id) {
  const idStr = String(id)
  const pais = []
  Object.keys(data).forEach(function (paiId) {
    const no = data[paiId]
    Object.keys(no.outputs || {}).forEach(function (saida) {
      filhosDaSaida(no, saida).forEach(function (filho) {
        if (filho === idStr) {
          pais.push({ id: paiId, saida: saida })
        }
      })
    })
  })

  return pais
}

export function arvoreDoCanvas(editor) {
  const data = dadosDosNos(editor)
  const raiz = Object.keys(data).find(function (id) {
    return tipoNoDoRegistro(data[id]) === 'gatilho'
  })
  if (!raiz) {
    return null
  }

  const visitados = {}
  function montar(id) {
    const no = data[id]
    if (!no) {
      return null
    }
    if (visitados[id]) {
      return {
        id: id,
        tipo_no: tipoNoDoRegistro(no),
        tipo: (no.data && no.data.tipo) || '',
        data: no.data || {},
        sim: [],
        nao: [],
        repetido: true,
      }
    }
    visitados[id] = true
    const tipoNo = tipoNoDoRegistro(no)
    const sim = filhosDaSaida(no, 'output_1').map(montar).filter(Boolean)
    const nao = tipoNo === 'condicao' ? filhosDaSaida(no, 'output_2').map(montar).filter(Boolean) : []

    return {
      id: id,
      tipo_no: tipoNo,
      tipo: (no.data && no.data.tipo) || '',
      data: no.data || {},
      sim: sim,
      nao: nao,
      repetido: false,
    }
  }

  return montar(raiz)
}

function fimDaCadeia(editor, id, saida) {
  const data = dadosDosNos(editor)
  let atualId = String(id)
  let atualSaida = saida || 'output_1'
  const visitados = {}

  while (data[atualId]) {
    const chave = atualId + ':' + atualSaida
    if (visitados[chave]) {
      break
    }
    visitados[chave] = true
    const filhos = filhosDaSaida(data[atualId], atualSaida)
    if (!filhos.length) {
      return { id: atualId, saida: atualSaida }
    }
    atualId = filhos[0]
    atualSaida = 'output_1'
  }

  return { id: String(id), saida: saida || 'output_1' }
}

export function adicionarNoFilho(editor, tipo, paiId, saida) {
  const ancora = fimDaCadeia(editor, paiId, saida)
  const data = dadosDosNos(editor)
  const ancoraNo = data[ancora.id] || {}
  const id = adicionarNo(
    editor,
    tipo,
    (ancoraNo.pos_x || 80) + 280,
    (ancoraNo.pos_y || 80) + (ancora.saida === 'output_2' ? 160 : 0)
  )
  if (!id) {
    return null
  }
  editor.addConnection(String(ancora.id), String(id), ancora.saida, 'input_1')

  return id
}

export function removerNoDoFluxo(editor, id) {
  const data = dadosDosNos(editor)
  const no = data[id]
  if (!no) {
    return
  }
  const pais = paisDoNo(data, id)
  const filhosSim = filhosDaSaida(no, 'output_1')
  const filhosNao = filhosDaSaida(no, 'output_2')
  editor.removeNodeId('node-' + id)
  pais.forEach(function (pai) {
    const destinos = pai.saida === 'output_2' ? filhosNao : filhosSim
    destinos.forEach(function (filhoId) {
      if (dadosDosNos(editor)[filhoId]) {
        editor.addConnection(String(pai.id), String(filhoId), pai.saida, 'input_1')
      }
    })
  })
}

export function removerRamoDoFluxo(editor, id) {
  const data = dadosDosNos(editor)
  const raiz = String(id)
  if (!data[raiz]) {
    return
  }
  const ids = []
  const visitados = {}
  function coletar(noId) {
    if (!data[noId] || visitados[noId]) {
      return
    }
    visitados[noId] = true
    ids.push(noId)
    filhosDaSaida(data[noId], 'output_1').forEach(coletar)
    filhosDaSaida(data[noId], 'output_2').forEach(coletar)
  }
  coletar(raiz)
  ids.forEach(function (noId) {
    if (!dadosDosNos(editor)[noId]) {
      return
    }
    editor.removeNodeId('node-' + noId)
  })
}

export function layoutAutomatico(editor, contexto) {
  if (!editor) {
    return
  }
  const data = dadosDosNos(editor)
  const posicoes = {}
  const visitados = {}
  let linha = 0
  const dx = 280
  const dy = 170

  function posicionar(id, profundidade) {
    if (!data[id] || visitados[id]) {
      return
    }
    visitados[id] = true
    posicoes[id] = {
      x: 60 + profundidade * dx,
      y: 50 + linha * dy,
    }
    const no = data[id]
    const sim = filhosDaSaida(no, 'output_1')
    const nao = tipoNoDoRegistro(no) === 'condicao' ? filhosDaSaida(no, 'output_2') : []
    sim.forEach(function (filho, indice) {
      if (indice > 0) {
        linha += 1
      }
      posicionar(filho, profundidade + 1)
    })
    nao.forEach(function (filho) {
      linha += 1
      posicionar(filho, profundidade + 1)
    })
  }

  const raiz = Object.keys(data).find(function (id) {
    return tipoNoDoRegistro(data[id]) === 'gatilho'
  })
  if (raiz) {
    posicionar(raiz, 0)
  }
  Object.keys(data).forEach(function (id) {
    if (posicoes[id]) {
      return
    }
    linha += 1
    posicoes[id] = { x: 60, y: 50 + linha * dy }
  })
  Object.keys(posicoes).forEach(function (id) {
    const registro = editor.drawflow.drawflow.Home.data[id]
    if (registro) {
      registro.pos_x = posicoes[id].x
      registro.pos_y = posicoes[id].y
    }
    const el = editor.precanvas.querySelector('#node-' + id)
    if (el) {
      el.style.top = posicoes[id].y + 'px'
      el.style.left = posicoes[id].x + 'px'
    }
    if (typeof editor.updateConnectionNodes === 'function') {
      editor.updateConnectionNodes('node-' + id)
    }
  })
  atualizarRotulosCanvas(editor, contexto)
}

export function rotuloBloco(tipo) {
  return ROTULOS[tipo] || { titulo: tipo, texto: tipo }
}

export function regrasDaCondicao(data) {
  if (!data) {
    return []
  }
  if (Array.isArray(data.regras) && data.regras.length) {
    return data.regras
  }
  if (data.tipo === 'campo') {
    return [{ campo_id: data.campo_id || null, op: data.op || 'preenchido', valor: data.valor == null ? null : data.valor }]
  }
  if (data.tipo === 'valor') {
    return [{ op: data.op || '>=', valor: data.valor == null ? null : data.valor }]
  }

  return [{ valor: data.valor == null ? null : data.valor }]
}

export function idsDoGatilho(data, lista, unico) {
  if (!data) {
    return []
  }
  if (Object.prototype.hasOwnProperty.call(data, lista) && Array.isArray(data[lista])) {
    return data[lista]
  }
  if (unico && data[unico] !== null && data[unico] !== undefined && data[unico] !== '') {
    return [data[unico]]
  }

  return []
}

export const LIMITE_REGRAS_CONDICAO = 20

export function iconeBloco(tipo) {
  return ICONES[tipo] || 'fas fa-circle'
}

export { ROTULOS }
